module.exports = __webpack_public_path__ + "img/icon-Zoom.30d665ca.png";